// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__8dCtE","closeIcon":"Alert_closeIcon__xjOoE"};